var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackArrowIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8094 12.6284L5.6822 7.50023L10.8094 2.37211C11.0841 2.09836 11.0841 1.65211 10.8094 1.37836C10.5356 1.10367 10.0894 1.10367 9.81563 1.37836L4.19063 7.00336C3.91595 7.27805 3.91595 7.72242 4.19063 7.99711L9.81563 13.6221C10.0894 13.8968 10.5356 13.8968 10.8094 13.6221C11.0841 13.3484 11.0841 12.9021 10.8094 12.6284Z",
    fill: "#555770"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackArrowIcon);
export default __webpack_public_path__ + "static/media/backArrowIcon.9f58c1e9840c984b2700c3c21deb22f5.svg";
export { ForwardRef as ReactComponent };